import axios from "axios";

const authLinkedin = code => {
	return axios.post("/api/linkedin", { code });
};

export { authLinkedin };



// WEBPACK FOOTER //
// ./src/actions/Careers/linkedinAction.js